import React from 'react';
import { MenuItem, InputAdornment } from '@mui/material';
import BadgeIcon from '@mui/icons-material/Badge';
import { status, STATUS_MODEL } from '../../../../../enums/statusEnum';
import 'react-phone-input-2/lib/material.css';
import { CustomTextField } from '../../../../../components/CustomTextField';
import { CustomDatePicker } from '../../../../../components/CustomDatePicker';
import { CustomSelect } from '../../../../../components/CustomSelect';
import { CustomSelectAndChildren } from '../../../../../components/CustomSelectAndChildren';
import { CustomPhoneInput } from '../../../../../components/CustomPhoneInput';
import { Mail } from '@mui/icons-material';
import { CustomPassword } from '../../../../../components/CustomPassword';
import { TrashOutlineIcon } from '../../../../../components/buttons/IconButtons';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import DetailsApp from '../Functionality/DetailsApp';
import { permissionObj } from '../../../../../Helpers/permission';
import { PIN_LENGTH } from '../Model/Models';
import { PASSWORD_MIN_LENGTH } from '../../../../../constant/variable';

const Step1Details = ({
    userData,
    onChange,
    emptyFields,
    isValidEmail,
    isValidDocumentId,
    isValidPin,
    isValidPhoneNumber,
    isValidDob,
    setIsValidDob,
    setModalShow,
    disable,
    sectionProfile = false,
}) => {
    const { t, DEV, permission, userInfoStatusList, contractorId, supplierId, canManagePasswords, userId } = DetailsApp({
        userData,
    });

    return (
        <div className={'row mt-4'}>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s1d_name'}
                    length={128}
                    name={'name'}
                    value={userData.name}
                    trans={'name'}
                    type={'text'}
                    disabled={disable}
                    onChange={onChange}
                    emptyFields={emptyFields}
                    required={true}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s1d_last_name'}
                    length={128}
                    name={'lastName'}
                    value={userData.lastName}
                    trans={'last_name'}
                    type={'text'}
                    disabled={disable}
                    onChange={onChange}
                    emptyFields={emptyFields}
                    required={true}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s1d_second_last_name'}
                    length={128}
                    disabled={disable}
                    name={'secondLastName'}
                    value={userData.secondLastName}
                    trans={'second_last_name'}
                    type={'text'}
                    onChange={onChange}
                    required={false}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s1d_document_id'}
                    length={20}
                    name={'documentId'}
                    value={userData.documentId}
                    trans={'documentId'}
                    type={'text'}
                    disabled={disable}
                    onChange={onChange}
                    required={false}
                    helperText={'document_id_format'}
                    isValid={isValidDocumentId}
                    isValidText={'document_id_format'}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position='end'>
                                <BadgeIcon />
                            </InputAdornment>
                        ),
                    }}
                    autoComplete={'off'}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s1d_email'}
                    length={128}
                    name={'email'}
                    value={userData.email}
                    trans={'email'}
                    type={'text'}
                    onChange={onChange}
                    emptyFields={userData?.id ? emptyFields: undefined}
                    required={ !!userData?.id}
                    disabled={disable}
                    isValid={isValidEmail}
                    isValidText={'email_format_invalid'}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position='end'>
                                <Mail />
                            </InputAdornment>
                        ),
                    }}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomPhoneInput
                    id='phit_s1d_phone_number'
                    value={userData.phoneNumber}
                    name={'phoneNumber'}
                    onChange={(e) => {
                        onChange({ target: { value: e, name: 'phoneNumber' } });
                    }}
                    required={false}
                    disabled={disable}
                    isValid={isValidPhoneNumber}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomSelect
                    id={'slt_s1d_gender_id'}
                    name={'genderId'}
                    value={userData.genderId}
                    key={userData.genderId}
                    keyName='id'
                    disabled={disable}
                    onChange={onChange}
                    list={[
                        { id: 1, name: t('male').toUpperCase() },
                        { id: 2, name: t('female').toUpperCase() },
                    ]}
                    trans={'gender'}
                    label={'lbl_s1d_genderId'}
                    required={false}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomDatePicker
                    id={'dp_s1d_dob'}
                    name={'dob'}
                    disabled={disable}
                    onChange={(e) => {
                        onChange({ target: { value: e, name: 'dob' } });
                    }}
                    trans={'dob'}
                    value={userData?.dob}
                    required={false}
                    disableFuture={true}
                    openTo={'year'}
                    onError={(error) => setIsValidDob(error === null)}
                    isValid={isValidDob}
                />
            </div>
            {userData?.statusId >= STATUS_MODEL.ACTIVE && (
                <div className='col-sm-12 col-xxl-6 col-lg-6'>
                    <CustomSelectAndChildren
                        id={'slt_s1d_status'}
                        name={'statusId'}
                        trans={'status'}
                        disabled={
                            disable || sectionProfile || parseInt(userData.statusId) === STATUS_MODEL.ACCOUNT_LOCKED
                        }
                        onChange={onChange}
                        value={userData.statusId}
                        showNoSelectionOption={false}
                        required={true}
                    >
                        {userInfoStatusList?.map((item) => (
                            <MenuItem key={item?.id} value={item?.id}>
                                {t(status[item?.id])}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>
            )}

            { (canManagePasswords || userData?.id === userId) &&
                <div className='col-sm-12 col-xxl-6 col-lg-6'>
                    <CustomPassword
                        id={'txt_s1d_password'}
                        name='password'
                        length={16}
                        minLength={PASSWORD_MIN_LENGTH}
                        value={userData?.password}
                        onChange={onChange}
                        disabled={disable}
                        label={'password'}
                        helperText={
                            userData?.id
                                ? 'fill_only_if_you_want_to_update_your_password'
                                : 'fill_this_field_only_if_you_want_to_your_password_custom'
                        }
                        autoComplete={'off'}
                    />
                </div>
            }
            {userData?.pin !== undefined && (
                <div className='col-sm-12 col-xxl-6 col-lg-6'>
                    <CustomTextField
                        id={'txt_s1d_pin'}
                        length={PIN_LENGTH.MAX}
                        name={'pin'}
                        value={userData?.pin}
                        trans={'pin'}
                        type={'number'}
                        onChange={onChange}
                        required={false}
                        helperText={t('enter_exactly_x_characters', { count: PIN_LENGTH.MAX })}
                        isValid={isValidPin}
                        isValidText={t('pin_invalid_rules', { count: PIN_LENGTH.MAX })}
                    />
                </div>
            )}
            {userData.id !== '' && userData.id !== null && sectionProfile && (
                <div className='col-sm-12 col-xxl-6 col-lg-6 d-flex align-items-center justify-content-between'>
                    <CustomTextField
                        id='txt_s1d_device_id'
                        length={128}
                        name='deviceId'
                        value={userData.deviceId}
                        trans='device_id'
                        type='text'
                        disabled
                        onChange={onChange}
                        required={false}
                        InputProps={{
                            endAdornment: (contractorId ||
                                supplierId ||
                                DEV ||
                                permission?.includes(permissionObj.WEB_PROFILE_UPDATE)) && (
                                <ButtonIcon
                                    id='btn_s1d_device_id'
                                    Icon={TrashOutlineIcon}
                                    className='btn-outlined-error-600-border-2px h-40px w-50px border-radius-right-8px'
                                    iconProps='icon-color-shades-600 btn-icon-svg-24px'
                                    disabled={!userData?.deviceId}
                                    onClick={() => {
                                        setModalShow(true);
                                    }}
                                />
                            ),
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default Step1Details;
